import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-exp-pdf-drop",
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./pdf-drop.component.html",
})
export class PdfDropComponent implements OnChanges {
  @Input() open = false;
  @Output() close = new EventEmitter<void>();
  @Output() uploaded = new EventEmitter<string>();

  @ViewChild("fileInput", { static: false })
  fileInput?: ElementRef<HTMLInputElement>;

  dragActive = false;
  private dragDepth = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["open"] && !changes["open"].currentValue) {
      this.dragActive = false;
      this.dragDepth = 0;
    }
  }

  onBackdropClick(e: MouseEvent): void {
    if (e.target === e.currentTarget) {
      this.close.emit();
    }
  }

  onCloseClick(): void {
    this.close.emit();
  }

  onZoneClick(): void {
    this.fileInput?.nativeElement.click();
  }

  onFileChange(e: Event): void {
    const input = e.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (file) this.handleFile(file.name);
    if (input) input.value = "";
  }

  @HostListener("document:keydown.escape")
  onEscape(): void {
    if (this.open) this.close.emit();
  }

  @HostListener("window:dragenter", ["$event"])
  onDragEnter(e: DragEvent): void {
    if (!this.hasFiles(e)) return;
    e.preventDefault();
    this.dragDepth++;
    if (this.dragDepth === 1) {
      this.dragActive = true;
    }
  }

  @HostListener("window:dragover", ["$event"])
  onDragOver(e: DragEvent): void {
    if (!this.hasFiles(e)) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = "copy";
  }

  @HostListener("window:dragleave", ["$event"])
  onDragLeave(e: DragEvent): void {
    if (!this.hasFiles(e)) return;
    this.dragDepth = Math.max(0, this.dragDepth - 1);
    if (this.dragDepth === 0) this.dragActive = false;
  }

  @HostListener("window:drop", ["$event"])
  onDrop(e: DragEvent): void {
    if (!this.hasFiles(e)) return;
    e.preventDefault();
    this.dragDepth = 0;
    this.dragActive = false;
    const file = e.dataTransfer?.files?.[0];
    if (file) this.handleFile(file.name);
  }

  private hasFiles(e: DragEvent): boolean {
    const types = e.dataTransfer?.types;
    if (!types) return false;
    for (let i = 0; i < types.length; i++) {
      if (types[i] === "Files") return true;
    }
    return false;
  }

  private handleFile(name: string): void {
    this.uploaded.emit(name);
  }
}
